// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__uYp36","spin":"spinner_spin__0t7B6"};